import { useQuery } from 'hooks/useCustomQuery';
import getPlatformNumberById from '@/API/PlatformNumber/getPlatformNumberById';

const useCheckCurrentDRNumber = (
    number,
    setSelectedNumber,
    setIsNumberChecked,
    setIsDrNumber,
    platformId,
    accountScope,
) => {
    return useQuery({
        queryKey: ['checkCurrentDRNumber', number?.numberID],
        queryFn: async () => {
            try {
                const res = await getPlatformNumberById(
                    number?.numberID,
                    platformId,
                    accountScope,
                );
                const newNumberIsDR =
                    res.trunkType === 'MS Direct Routing' ||
                    res.trunkType === 'MS Direct Routing GCC High';
                setSelectedNumber(res || null);
                setIsDrNumber(newNumberIsDR);
                setIsNumberChecked(true);

                return res;
            } catch (error) {
                console.error('Error checking number:', error);
                throw error;
            }
        },
        enabled: number !== undefined && number?.numberID !== undefined,
        refetchOnWindowFocus: false,
        cacheTime: 0,
        staleTime: 0,
    });
};

export default useCheckCurrentDRNumber;
